/* eslint-disable eqeqeq */
  
function isWeiXin() {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  }

  function appendParams(params, url) {
    var baseWithSearch = url.split('#')[0];
    var hash = url.split('#')[1];
    for (var i = 0; i < params.length; i++) {
        if (params[i].value !== undefined) {
            var newParam = params[i].key + "=" + params[i].value;
            if (baseWithSearch.indexOf('?') > 0) {
                var oldParamReg = new RegExp(params[i].key + '=[-\\w]{0,40}', 'g');

                if (oldParamReg.test(baseWithSearch)) {
                    baseWithSearch = baseWithSearch.replace(oldParamReg, newParam);
                } else {
                    baseWithSearch += "&" + newParam;
                }
            } else {
                baseWithSearch += "?" + newParam;
            }
        }
    }
    if (hash) {
        url = baseWithSearch + '#' + hash;
    } else {
        url = baseWithSearch;
    }
    return url;
  }
 function  getUrlParams(key) {
    var args = {};
    var pairs = window.location.search.substring(1).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pos = pairs[i].indexOf('=');
        if (pos === -1) {
            continue;
        }
        args[pairs[i].substring(0, pos)] = decodeURIComponent(pairs[i].substring(pos + 1));
    }
    return args[key];
  }
export {isWeiXin,appendParams,getUrlParams}